import {
  Banner,
  BlockStack,
  Box,
  Button,
  Card,
  Icon,
  InlineStack,
  Layout,
  Page,
  SkeletonBodyText,
  SkeletonPage,
  Toast,
  Popover,
  ActionList,
} from "@shopify/polaris";
import { RecommendApp } from "@channelwill/components"
import React, { useCallback, useEffect, useState } from "react";
import { NotificationIcon, MenuHorizontalIcon, XIcon } from "@shopify/polaris-icons";
import "./new_dash.css";
import {
  reqGetNewDashboardData,
  reqPostBaseAction,
  reqPostCardDismiss,
} from "../../../../api";
import PropertyBox from "./PropertyBox";
import ManagerBox from "./ManagerBox";
import NewPersonBox from "./NewPersonBox";
import FulfilledOrders from "./FulfilledOrders";
import AbilityBox from "./AbilityBox";
import AppRecommendation from "../../../../components/AppRecommendation";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from "../../../../utils/utils";
// import { useSelector } from "react-redux";
import { store } from "../../../../store";
import { setInitialPath } from "../../../../slice";
import SheetContactUs from "../../../../components/ContactUsSheetExample/SheetExample";
import { useSelector } from "react-redux";
const DashboardClass = ({ handleModalCallback }) => {
  const router = useHistory();
  const shopify = window.shopify;
  const [initPage, setInitPage] = useState(true); //页面初始化
  const [pageData, setPageData] = useState(); //首页数据
  const [newPerson, setNewPerson] = useState(false); //新人引导
  const [achiveBanner, setAchiveBanner] = useState(false); //成就banner
  const [hasSale, setHasSale] = useState(false); //是否展示销售
  const [isPartners, setIsPartners] = useState(false); //是否展示推荐app
  const [newPartnerBanner,setNewPartnerBanner] = useState(false) // 新增partner广告
  const [liveBanner,setLiveBanner] = useState(false) // 新增live banner
  const [liveBannerDismiss,setLiveBannerDismiss] = useState(false) // 新增live banner dismiss
  const shopify_level = useSelector(
    (state) => state.languageReducer.subScriptData.shopify_level
  );
  const toLowerCase = (str) => {
    return str.toLowerCase();
  };
  const shopifyLevel = () => {
    let flag = true;
    if (
      toLowerCase(shopify_level).indexOf('dev') !== -1 ||
      toLowerCase(shopify_level).indexOf('staff') !== -1
    ) {
      flag = false;
    }
    return flag;
  };
  
  // 获取页面数据
  const getData = async () => {
    setInitPage(true);
    let url = new URLSearchParams(window.location.search);
    let points = url.get("points");
    let params = {};
    if (points) {
      params.points = 1;
    }
    try {
      let res = await reqGetNewDashboardData(params);
      if (res.code === "200") {
        setPageData(res.data);
        if (res.data.ads_type === 1 && shopifyLevel()) {
          setNewPartnerBanner(res.data.ads)
        }else if (res.data.ads_type === 2) {
          setLiveBanner(res.data.ads)
        }
        
        if (res.data?.user_guide?.show_survey) {
          // window.onBoarding(plan_level);
        }
        if (res.data.reached_orders > 0) {
          setAchiveBanner(true);
        }
        if (res.data.onBoarding) {
          setNewPerson(true);
        }
        if (
          Object.values(res.data.sale_info).length > 0 ||
          Object.values(res.data.agent_info).length > 0
        ) {
          setHasSale(true);
        }
        if (res.data.app_recommend > 0) {
          setTimeout(() => {
            setIsPartners(true);
          }, 1000);
        }
      }
       setTimeout(() => {
            setInitPage(false);
          }, 1000);
      setTimeout(() => {
        // 清除链接参数
        var currentUrl = window.location.href;
        if (currentUrl.indexOf("?") !== -1) {
          currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
          if (!!(window.history && window.history.pushState)) {
            window.history.pushState({}, 0, currentUrl);
          }
        }
         
      }, 2000);
    } catch (error) {}
  };

  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      getData();
    }
    return () => {
      isMount = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 关闭banner 方法
  const handleCloseBanner = async (val) => {
    let res = await reqPostCardDismiss({ type: val });
    if (res.code === "200") {
      setAchiveBanner(false);
      toastFun("Saved successfully", false);
    } else {
      toastFun("Saved failed", false);
    }
  };
  const handleNewParnter = async (val) => {
    const params = {
      type: val,
    };
    let res = await reqPostBaseAction(params);
    if (res.code === '200') {
      setNewPartnerBanner(false)
    }
  };
  const handleLiveBanner = async (val) => {
    const params = {
      type: val,
    };
    let res = await reqPostBaseAction(params);
    if (res.code === '200') {
      setLiveBanner(false)
    }
  };
  const [toast, setToast] = useState(false);
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };
  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const initSkeletonPage = (
    <div className="skeleton_page_children" style={{ padding: "0 2rem",marginTop: "24px" }}>
      <SkeletonPage fullWidth={false} primaryAction>
        <Layout>
          <Layout.Section>
          <BlockStack gap={400}>
            <Card>
              <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
            <Card>
              <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={2} />
              </BlockStack>
            </Card>
            <Card>
              <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
            <Card>
              <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
             <Card>
              <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={1} />
              </BlockStack>
            </Card>
            </BlockStack>
          </Layout.Section>
        </Layout>
      </SkeletonPage>
    </div>
  );

  // let owerName = utils.getStore("S_SHOP_OWNER") || window.S_SHOP_OWNER;
  const pageContent = (
    <Page 
    title={ <Box
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        fontWeight: 650,
        fontSize: "16px",
      }}
    >
      <h1
        style={{ fontWeight: 650, fontSize: "16px", marginRight: "8px" }}
      >
        Welcome to Dropshipman by
        <span className="dashboard_title_mobile_span">
          {" "}
          <span
            className="dashboard_title_mobile_span_line"
            onClick={() => {
              utils.routeListen("/admin/recommended-apps");
              // utils.routeJump1(router, "/admin/recommended-apps");
            }}
            style={{
              cursor: "pointer",
              color: "#676BFB",
              fontWeight: 650,
            }}
          >
            Channelwill
          </span>
        </span>
      </h1>
    </Box>}
    secondaryActions={[
      {
        content: <InlineStack gap={100} blockAlign="center">
        <Icon source={NotificationIcon} />
        <span>{pageData?.unread_count} notifications</span>
      </InlineStack>,
        accessibilityLabel: 'notifications',
        onAction: () =>  utils.routeJump1(router, "/admin/messages"),
      },
    ]} 
    actionGroups={[
      {
        title: '⭐️ Resource️',
        actions: [
          {
            content: 'Help Center',
            accessibilityLabel: 'Individual action label',
            onAction: () => {
              window.open("https://help.dropshipman.com/", "_blank");
            },
          },
          {
            content: 'Affiliate',
            accessibilityLabel: 'Individual action label',
            onAction: () => {
              utils.routeJump1(router, "/admin/partnerShip/affiliate")
            },
          },
          {
            content: 'Community',
            accessibilityLabel: 'Individual action label',
            onAction: () => {
              window.open("https://discord.com/invite/FXPB6vCEbt", "_blank");
            },
          },
          {
            content: 'Partners',
            accessibilityLabel: 'Individual action label',
            onAction: () => {
              utils.routeJump1(router, "/admin/recommended-apps?selected_tab=1")
            },
          },
        ],
      },
    ]}>
      <Box className="dashboard_page_box">
        {/* 标题 */}
        
        <BlockStack gap={400}>

        {liveBanner && (
            <Box className="dashboard_banner live_banner" style={{position: 'relative'}}>
              <Banner
                hideIcon={true}
                title={`Chatwill - AI Chatbot`}
                onDismiss={() => {
                  handleLiveBanner('ads_chat');
                }}
                action={{ content: "Completely Free", url: "https://share.channelwill.com/kjm6dkAc",external: true }}
              >
                <p>
                FREE AI chatbot that turns visitors into buyers.
                </p>
              </Banner>
              <div style={{position: 'absolute', right: 0, top: '6px'}}>
              <Popover
              active={liveBannerDismiss}
              activator={<Button variant="tertiary" onClick={()=>{setLiveBannerDismiss(true)}}>
              <Icon
              source={MenuHorizontalIcon}
              tone="base"
            />
            </Button>}
              autofocusTarget="first-node"
              onClose={()=>{setLiveBannerDismiss(false)}}
              >
                <ActionList
                actionRole="menuitem"
                items={[{content:<div onClick={()=>{handleLiveBanner('ads_chat')}} style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}><Icon
                  source={XIcon}
                  tone="base"
                />
               {"Dismiss"}</div>}]}
              />
            </Popover>
            </div>
            </Box>
          )}
          {/* {newPartnerBanner && (
            <Box className="dashboard_banner" >
              <Banner
                hideIcon={true}
                title={`Adoric  Bundles Quality Breaks`}
                onDismiss={() => {
                  handleNewParnter('ads');
                }}
                action={{ content: "Start your free trial today!", url: "https://apps.shopify.com/adoric-bundles-quantity-breaks?utm_source=Dropshipman&utm_medium=Partnership&utm_campaign=In-app+&utm_term=In-app-promotion",external: true }}
              >
                <p>
                Boost your dropshipping profits with smart product bundles this BFCM! Easy setup, no coding needed.
                </p>
              </Banner>
              <div>
              
              </div>
            </Box>
          )} */}
          {newPartnerBanner && (
            <Box className="dashboard_banner" >
              <Banner
                hideIcon={true}
                title={`Protectify Shipping Protection`}
                onDismiss={() => {
                  handleNewParnter('ads');
                }}
                action={{ content: "Try it free today!", url: "https://apps.shopify.com/protectify-shipping-protectio?source=dropshipman_dashboard",external: true }}
              >
                <p>
                Protect your orders from loss, damage, or theft — and turn protection into profit.
                </p>
              </Banner>
              <div>
              
              </div>
            </Box>
          )}
          
          {/* 横幅 */}
          {(!newPartnerBanner && achiveBanner) && (
            <Box className="dashboard_banner">
              <Banner
                hideIcon={true}
                title={`Congratulations on reaching ${pageData?.reached_orders} orders in the past 30 days!`}
                onDismiss={() => {
                  handleCloseBanner(1);
                }}
                // action={{ content: "Upgrade now", url: "/admin/subscribe" }}
              >
                <p style={{ minHeight: "40px" }}>
                  Congratulations! Your store's recent orders have reached{" "}
                  {pageData?.reached_orders}, marking a new milestone. We
                  recommend selecting Dropshipman {pageData?.recommend_plan}{" "}
                  plan to help elevate your dropshipping business to the next
                  level.
                </p>
                <Box
                  className="dashboard_banner_button"
                  style={{ marginTop: "10px" }}
                >
                  <Button
                    size="slim"
                    onClick={() => {
                      store.dispatch(setInitialPath("/admin/dashboard"));
                      if (shopify) {
                        handleModalCallback(
                          "/admin/subscribe",
                          "Plan_Page_Modal"
                        );
                      } else {
                        utils.routeJump1(router, "/admin/subscribe");
                      }
                    }}
                  >
                    Upgrade now
                  </Button>
                </Box>
              </Banner>
            </Box>
          )}
          {/* 订单统计 */}
          {pageData?.dsm_paid > 0 && (
            <Box className="dashboard_order_statistics">
              <FulfilledOrders />
            </Box>
          )}
          {/* 新人引导模块 */}
          {newPerson && (
            <Box className="dashboard_new_person">
              <NewPersonBox
                router={router}
                toastFun={toastFun}
                data={pageData?.user_guide}
                newPerson={newPerson}
                setNewPerson={setNewPerson}
                setPageData={setPageData}
              />
            </Box>
          )}
          {/* 资产卡片 */}
          <Box className="dashboard_property">
            <PropertyBox pageData={pageData} router={router} />
          </Box>
          {pageData?.dsm_paid !== 0 && <RecommendApp  />}
          {/* 订单统计 */}
          {pageData?.dsm_paid === 0 && (
            <Box className="dashboard_order_statistics">
              <FulfilledOrders />
            </Box>
          )}
          {pageData?.dsm_paid === 0 && <RecommendApp  />}
          {/* 销售或者Agent角色 */}
          {hasSale && (
            <Box className="dashboard_sale">
              <ManagerBox
                pageData={pageData}
                toastFun={toastFun}
                handleCloseBanner={handleCloseBanner}
                setHasSale={setHasSale}
              />
            </Box>
          )}

          {/* 用户分层 功能卡片 */}
          <Box className="dashboard_user_layer">
            <AbilityBox
              router={router}
              handleModalCallback={handleModalCallback}
              data={pageData}
              toastFun={toastFun}
              setPageData={setPageData}
            />
          </Box>
          {/* 推荐APP列表 */}
          {isPartners ? (
            <Box className="dashboard_recommend_app">
              <AppRecommendation
                show={isPartners}
                setIsPartners={() => setIsPartners(false)}
                history={router}
              />
            </Box>
          ) : (
            ""
          )}
        </BlockStack>
      </Box>
      <SheetContactUs
        helpCenterText={'Dropshipman'}
        helpCenterLink={'https://www.dropshipman.com/blog'}
      />
    </Page>
  );
  return (
    <div className="skeleton_page">
      {initPage && initSkeletonPage}
      <div style={{opacity: initPage ? 0 : 1}}>
        {pageContent}
      </div>
      {/* {initPage ? initSkeletonPage : pageContent} */}
      {toastMarkup}
    </div>
  );
};

export default DashboardClass;
